import moment from "jalali-moment";
import {withRouter} from "next/router";
import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 25px;
  width: 300px;
  height: 350px;
`;

const PhotoContainer = styled.a`
  height: 300px;
  transition: border-radius 0.3s;
  overflow: hidden;
  width: 300px;
  cursor: pointer;
`;

const Photo = styled.img`
  width: 100%;
  height: 100%;
`;

const RankContainer = styled.div`
  color: #aaa;
  font-size: 0.75rem;
  text-align: center;
  margin-top: 5px;
`;

const Info = styled.a`
  text-align: center;
  margin-top: 0.5rem;
  text-decoration: none;
  cursor: pointer;
`;

const Title = styled.h3`
  color: black;
  font-size: 0.85em;
  margin: 0;
`;

const Year = styled.span`
  color: #aaa;
  font-size: 0.6em;
  font-weight: bold;
  margin: 0;
`;

class WinItem extends React.Component {
  render() {
    const win = this.props.win;
    const current_language = this.props.router.locale;

    return (
      <Container>
        <PhotoContainer href={win.link}>
          <Photo src={win.cover} />
          <RankContainer>{win.rank}</RankContainer>
        </PhotoContainer>
        <Info href={"/works/" + win.project_slug}>
          <Title>{win.title}</Title>
          <Year>
            {moment(win.created_at, "YYYY-M-D").locale(current_language).format("YYYY")}
          </Year>
        </Info>
      </Container>
    );
  }
}

export default withRouter(WinItem);
